import React from 'react';

import { useIntl } from 'react-intl';

// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports
import { AtlassianNavigation } from '@atlaskit/atlassian-navigation/atlassian-navigation';
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports
import { ProductHome } from '@atlaskit/atlassian-navigation/product-home';
import { AtlassianIcon } from '@atlaskit/logo/atlassian-icon';
import { getHistory } from '@atlassian/ptc-common/store';

import { AddPeopleButton } from './AddPeopleButton';
import AtlassianSwitcherItem from './AtlassianSwitcher';
import { CreateTeamButton } from './CreateTeamButton';
import { messages } from './messages';
import { TeamsAppLogo } from './TeamsAppLogo';
import UserMenu from './UserMenu';

const isWithMetaKey = (event: React.MouseEvent): boolean =>
	!!(event && (event.metaKey || event.shiftKey || event.altKey || event.ctrlKey));

const DirectoryHome = () => {
	const intl = useIntl();
	const navigate = (event: React.MouseEvent) => {
		const withMetaKey = isWithMetaKey(event);

		if (!withMetaKey) {
			event.preventDefault();
		}

		getHistory().push('/search');
	};

	return (
		<ProductHome
			icon={AtlassianIcon}
			logo={TeamsAppLogo}
			href="/search"
			onClick={navigate}
			aria-label={intl.formatMessage(messages.teamsLabel)}
		/>
	);
};

export const Navigation = (): React.JSX.Element => {
	const intl = useIntl();

	return (
		<AtlassianNavigation
			label={intl.formatMessage(messages.teamsLabel)}
			renderAppSwitcher={AtlassianSwitcherItem}
			renderProfile={UserMenu}
			primaryItems={[<CreateTeamButton key="createPeople" />, <AddPeopleButton key="addPeople" />]}
			renderProductHome={DirectoryHome}
		/>
	);
};
